const o="hiero-sdk-js",s="2.78.0";export{o as SDK_NAME,s as SDK_VERSION};
//# sourceMappingURL=version.js.map
